module.exports = __webpack_public_path__ + "img/Triangle.784d2087.svg";